import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Cash Marker"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-cash-marker',
    templateUrl: './icon-cash-marker.component.html',
    styleUrls: ['./icon-cash-marker.component.scss'],
    standalone: false
})
export class IconCashMarkerComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
